import {
    useMemo
} from "react";
import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    Mutable
} from "../../../../types";
import {
    MOTION_CSS_EASINGS
} from "../../../../helpers/motion";
import {
    webStyle
} from "../../../../utils";

export const BUBBLE_TYPING_DOT_COUNT = 3;

export const BUBBLE_TYPING_CYCLE_STEPS = 3;

export const BUBBLE_TYPING_REST_OPACITY = 0.4;

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "center",
        flexDirection: "row"
    }
});

export const useStyles = ({
    lineHeight,
    durations,
    iconSizes,
    radiuses,
    colors,
    spaces
}: {
    colors: NCoreUIKit.ActivePalette["colors"];
    spaces: NCoreUIKit.ActivePalette["spaces"];
    durations: NCoreUIKit.Durations;
    iconSizes: NCoreUIKit.IconSizes;
    radiuses: NCoreUIKit.Radiuses;
    lineHeight: number;
}) => {
    const webPulse = useMemo(() => {
        const cycle = durations.long * BUBBLE_TYPING_CYCLE_STEPS;

        const riseEnd = `${durations.medium / cycle * 100}%`;

        const fallEnd = `${durations.medium * 2 / cycle * 100}%`;

        return StyleSheet.create({
            pulse: webStyle({
                animationKeyframes: {
                    [riseEnd]: {
                        transform: `translateY(${-spaces.spacingXs}px)`,
                        opacity: 1
                    },
                    [`0%, ${fallEnd}, 100%`]: {
                        opacity: BUBBLE_TYPING_REST_OPACITY,
                        transform: "translateY(0px)"
                    }
                },
                animationTimingFunction: MOTION_CSS_EASINGS.inOut,
                animationIterationCount: "infinite",
                animationDuration: `${cycle}ms`,
                animationFillMode: "backwards"
            })
        }).pulse;
    }, [
        durations.medium,
        durations.long,
        spaces.spacingXs
    ]);

    const styles = {
        dot: {
            backgroundColor: colors.content.icon.high,
            height: iconSizes.small / 2,
            width: iconSizes.small / 2,
            borderRadius: radiuses.full
        } as Mutable<ViewStyle>,
        container: {
            gap: spaces.spacingXs,
            height: lineHeight
        } as Mutable<ViewStyle>,
        webPulse
    };

    return styles;
};
export default stylesheet;
